import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Utility from '../../services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import Util from '../../../shared/util/util'
import moment from 'moment';
import iptracker from '../../../../views/components/commonfunction/iptracker';

export default {
    name: 'updateappointmentdate',
    components: {
      //VueElementLoading,
      Treeselect,
      Paginate,
      BasicSelect,
      Utility,
      vueMultiSelect,
      Loader,
      iptracker,
      Util
    },
    data: function() {
        return {
            shipmentid:'',
            shipmentErr:'',
            isLoading: false,
            showAppointmentDate:false,
            appointmentdate:'',
            disableflag:true,
            comments:'',
            commentErr:'',
            userdetail:{}
          }
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userName = userdetail.email;
        this.userdetail = userdetail;
      },
      methods: {
        async getShipmentDetails(){
            if(this.validator())return;
            this.comments = ''
            this.isLoading = true 
            let input = {
                "parentawb":this.shipmentid.trim()
            }
            let result = await Utility.getAppointmentDateDetails(input)
            if(result.data.code == 200 ){
                this.appointmentdate = result.data.data.AppointmentDate!=null?moment.utc(result.data.data.AppointmentDate).format('YYYY-MM-DD'):result.data.data.AppointmentDate
                this.disableflag = this.appointmentdate == null ? false : true
                this.showAppointmentDate = true
                this.comments = ''
            }
            else{
                this.showAppointmentDate = false
                this.$alertify.error(result.data.message);
            }
            this.isLoading = false
        },
        async EditDate(){
            this.disableflag = false
        },
        async onSubmit(){
            this.isLoading = true 
            let updateInput = {
                "ShippingID":this.shipmentid,
                "appointmentdate":this.appointmentdate,
                "lastmodifiedby":this.userName,
                "comments":this.comments
            }
            let result = await Utility.UpdateAppointmentDate(updateInput)
            if(result.data.code == 200){
                this.getTraceIP(updateInput)
                this.$alertify.success("Appointment Date Updated Successfully !");
                this.disableflag = true
            }else if (result.data.code == 400){
                    this.$alertify.error(result.data.message);
            }else{
                this.$alertify.error(result.data.data);
            }
            this.isLoading = false 
        },
        getTraceIP(data) {
            try {
                let payload = 
                {
                "projectname": this.userdetail.project,
                "type": "web",
                "userid": this.userdetail.userid,
                "username": this.userdetail.username,
                "routeurl":'/changereattemptdate',
                "meta" : {
                    "event" : `Re Attempt Date`,
                    "data" : data
                }
            }
            let result = iptracker.getTraceIP(payload);
            } catch (error) {
                console.log(error)
            }
        },
        reset(){
            this.isLoading = true;
            this.shipmentid = '';
            this.shipmentErr = '';
            this.appointmentdate = '';
            this.showAppointmentDate = false;
            this.comments = '';
            this.commentErr='';
            this.isLoading = false;
        },
        validator(){
            let err = 0
            if(this.shipmentid==''||this.shipmentid==null){
                this.shipmentErr = "Please Enter AWB Number"
                err = 1
            }
            return err
        }
      }
}


// WEBPACK FOOTER //
// ./src/modules/utility/views/changereattempdate/changereattempdate.component.js